import { Box, Paper, Stack, Typography } from "@mui/material";
import React from "react";

export const UrgencyChartSection = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "31px 20px 34px",
        backgroundColor: "white",
        borderRadius: "20px",
        border: "1.5px solid #062059",
        boxShadow: "-8px 8px 0px #b7b9d0",
        overflow: "hidden",
        position: "relative",
        width: "100%",
			maxWidth:"90%",
				margin:"32px auto;",
				
      }}
    >
      <Stack
		  direction={{ xs: "column-reverse", sm: "row" }}
		  spacing={{ xs: 5.5, sm: 5.375 }}
		  alignItems="center"
		  justifyContent="center"
		  width="100%"
		>
        <Typography
          color="#062059"
          sx={{
            maxWidth: "359px",
            textAlign:{ xs: 'center', sm: 'left' }
          }}
        >
          <Box component="span" style={{fontWeight:"800"}}>
            Don&apos;t wait—early <span style={{whiteSpace:"nowrap"}}>communication is</span> important
          </Box>
          <Box component="br" />
          to help manage side effects and keep you as comfortable as possible while
          taking IBTROZI.
        </Typography>

        <Box
          component="img"
          src="/images/about-ibtrozi/convo-icon-desktop.svg"
          alt=""
          sx={{
            width: "190.5px",
            height: "112.5px",
            objectFit: "cover",
          }}
        />
      </Stack>
    </Paper>
  );
};
